import { fk, attr } from 'redux-orm'
import Base from './Base'

class MatchProposal extends Base {
  static get fields() {
    return {
      id: attr(),
      dossierCandidateIds: attr(),
      consultationTypeCandidateIds: attr(),
      eventId: fk({to: 'event', as: 'event', relatedName: 'matchProposals'}),
    }
  }
}

MatchProposal.modelName = 'matchProposal'

export default MatchProposal
